import { render, staticRenderFns } from "./MainNews.vue?vue&type=template&id=77699630&scoped=true&"
import script from "./MainNews.vue?vue&type=script&lang=js&"
export * from "./MainNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77699630",
  null
  
)

export default component.exports